export default __webpack_public_path__ + "static/media/suiteImg2.8701515d.png";